/**
 * SideBarPanel - Collapsible Content
 * Displays list of App with collapsible Sub Menu
 *
 * @version 1.0.1
 * @author [Gopinath Bhathey Srinivasan](https://github.com/gopinath-sixt)
 */
import * as React from 'react'

import {getAnchorProperties} from './utils.SideBarPanel'
import {ImageCollections} from '../../utils/imageImports'
import {isMobile} from '../../utils/genericUtils'
import {NavLink} from 'react-router-dom'
import classNames from 'classnames'
import {IProps, IData} from './SideBarPanel.d'
import SubMenu from './SubMenu'
import './sideBarPanel.scss'
import {useQuery} from '@apollo/client'
import {getEmployeeDetailsFromIAM} from '../../queries/employeeQuery'
import LoginAsInfo from './LoginAsInfo'

const SideBarPanel = (props: IProps) => {
  const {expand = false, onCollapse} = props

  useQuery(getEmployeeDetailsFromIAM, {
    variables: {empId: null},
  })

  const onClose = () => {
    onCollapse(false)
  }
  const anchorProperties = getAnchorProperties()
  const releaseNotesHoverText =
    'This link is redirecting to Confluence. You need to have Confluence permission to be able to see the Release Notes.'
  return (
    <div className={classNames('sidebar-collapsible', {expanded: expand})}>
      <ul>
        <li className="main-home" onClick={onClose}>
          <img src={ImageCollections.ico_house} alt="Home" />
          <NavLink to="/">Home</NavLink>
        </li>
        {anchorProperties.map((list: IData, index) => (
          <React.Fragment key={index}>
            {list.subMenu && <SubMenu list={list} onCollapse={onClose} />}
            {!list.subMenu && (
              <li key={index} onClick={onClose}>
                {list.iconName && (
                  <img src={ImageCollections[list.iconName]} alt={list.name} />
                )}
                {list.to &&
                  (list.targetBlank ? (
                    <a
                      target="_blank"
                      href={list.to}
                      rel="noopener noreferrer"
                      title={
                        list.name === 'Release Notes'
                          ? releaseNotesHoverText
                          : ''
                      }
                    >
                      {list.name}
                    </a>
                  ) : (
                    <NavLink to={list.to}>{list.name}</NavLink>
                  ))}
              </li>
            )}
          </React.Fragment>
        ))}
        {isMobile() && (
          <li>
            <NavLink
              className={({isActive}) => (isActive ? 'active' : '')}
              to="/logout"
            >
              Logout
            </NavLink>
          </li>
        )}
        <li className="login-as-li">
          <LoginAsInfo />
        </li>
      </ul>
    </div>
  )
}

export default SideBarPanel
